import { render, staticRenderFns } from "./SelectTemplateField.vue?vue&type=template&id=c5e60894&lang=pug&"
import script from "./SelectTemplateField.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e60894')) {
      api.createRecord('c5e60894', component.options)
    } else {
      api.reload('c5e60894', component.options)
    }
    module.hot.accept("./SelectTemplateField.vue?vue&type=template&id=c5e60894&lang=pug&", function () {
      api.rerender('c5e60894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/SelectTemplateField.vue"
export default component.exports